import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export function AnularProcesso({ pid, ref_, onDeleted, open, setOpen }) {
  const [confirmRef, setConfirmRef] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const doDelete = async () => {
    setBusy(true);
    try {
      await api.delete(`/processes/${pid}`, { params: { reason: reason.trim() || undefined } });
      toast.success(`Processo ${ref_} anulado`);
      onDeleted();
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!busy) { setOpen(o); if (!o) { setConfirmRef(""); setReason(""); } } }}>
      <AlertDialogContent data-testid="anular-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-ec-green">Anular o processo {ref_}?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta ação é <strong>permanente</strong>. Todos os documentos, ficheiros, histórico e emails
            associados a este processo serão apagados definitivamente e não poderão ser recuperados.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-slate-500">Motivo da anulação (opcional)</label>
            <Input value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder="Ex.: proposta cancelada pelo comprador" className="mt-1" data-testid="anular-reason" />
          </div>
          <div>
            <label className="text-xs text-slate-500">Para confirmar, escreva a referência <span className="font-mono font-semibold">{ref_}</span></label>
            <Input value={confirmRef} onChange={(e) => setConfirmRef(e.target.value)}
              placeholder={ref_} className="mt-1" data-testid="anular-confirm-ref" />
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="anular-cancel">Cancelar</AlertDialogCancel>
          <button onClick={doDelete} disabled={confirmRef.trim().toUpperCase() !== ref_.toUpperCase() || busy}
            data-testid="anular-confirm-btn"
            className="inline-flex items-center justify-center gap-1.5 text-sm px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Trash2 size={15} />} Anular definitivamente
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
